import {
  createContext,
  type ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react'

interface RateContextType {
  selectedRate: {
    rateIndex: number
    roomIndex: number
    rateId?: string
  } | null
  onSelectRate: (rateIndex: number, roomIndex: number, rateId?: string) => void
  clearSelection: () => void
}

interface RateProviderProps {
  children: ReactNode
}

const RateSelectionContext = createContext<RateContextType>({
  selectedRate: null,
  onSelectRate: () => null,
  clearSelection: () => null,
})

export const useRateSelection = () => {
  const context = useContext(RateSelectionContext)

  if (!context) {
    throw new Error(
      'useRateSelection deve ser usado dentro de um RateSelectionProvider',
    )
  }

  return context
}

export const RateSelectionProvider = ({ children }: RateProviderProps) => {
  const [selectedRate, setSelectedRate] = useState<{
    rateIndex: number
    roomIndex: number
    rateId?: string
  } | null>(null)

  const onSelectRate = useCallback(
    (rateIndex: number, roomIndex: number, rateId?: string | undefined) => {
      setSelectedRate({
        rateIndex,
        roomIndex,
        rateId,
      })
    },
    [],
  )

  const clearSelection = useCallback(() => {
    setSelectedRate(null)
  }, [])

  const value = {
    selectedRate,
    onSelectRate,
    clearSelection,
  }

  return (
    <RateSelectionContext.Provider value={value}>
      {children}
    </RateSelectionContext.Provider>
  )
}

export { RateSelectionContext }
